import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';
import { Location } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import * as CONSTATNT_DATA from 'app/constData';
import { MessageService } from 'primeng/api';


@Injectable({
  providedIn: 'root'
})
export class CommonServicesService {

  constructor(private _location: Location, private _toastr: MessageService, private _sanitizer: DomSanitizer,   ) { }

 toast(status: string, msg: string, title?: string) {
  const normalized = status.toLowerCase();
  const allowed = ['success', 'info', 'warn', 'error'];

  if (allowed.includes(normalized)) {
    this._toastr.add({
      severity: normalized as 'success' | 'info' | 'warn' | 'error',
      summary: title || normalized,
      detail: msg,
      life: 1000
    });
  } else {
    console.warn(`Invalid toast status: ${status}`);
  }
}


  jsonDownloadbale(myJson: any, processName: string) {
    let sJson = JSON.stringify(myJson);
    let element = document.createElement('a');
    element.setAttribute('href', "data:text/json;charset=UTF-8," + encodeURIComponent(sJson));
    element.setAttribute('download', `${processName}.json`);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click(); // simulate click
    document.body.removeChild(element);
  }

  showConfirmationDialog(text?, confirmButtonText?, cancelButtonText?) {
    return new Promise((resolve) => {
      Swal.fire({
        title: 'Confirmation',
        text: text ? text : 'Are you sure you want to proceed?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#7367f0',
        cancelButtonColor: '#d33',
        confirmButtonText: confirmButtonText ? confirmButtonText : 'Yes',
        cancelButtonText: cancelButtonText ? cancelButtonText : 'No'
      }).then((result) => {
        if (result.isConfirmed) {
          resolve(true); // User clicked "Yes", resolve the promise with true
        } else {
          resolve(false); // User clicked "No" or closed the dialog, resolve with false
        }
      });
    });
  }

  goBack(): void {
    this._location.back();
  }

  swapItems(control, index1: number, index2: number) {
    const item1 = control.controls[index1];
    const item2 = control.controls[index2];
    control.setControl(index1, item2);
    control.setControl(index2, item1);
  }

  renderIcon(inputType: string) {
    switch (inputType) {
      case 'textarea':
        return this._sanitizer.bypassSecurityTrustHtml(`<i data-feather="clipboard" class="feather icon-clipboard"></i>`);

      case 'input':
        return this._sanitizer.bypassSecurityTrustHtml(`<i data-feather="edit" class="feather icon-edit"></i>`);

      case 'Accordion':
        return this._sanitizer.bypassSecurityTrustHtml(`<i data-feather="chevrons-down" class="feather icon-chevrons-down"></i>`);

      case 'input-search':
        return this._sanitizer.bypassSecurityTrustHtml(`<i data-feather="search" class="feather icon-search"></i>`);

      case 'autocomplete-common':
        return this._sanitizer.bypassSecurityTrustHtml(`<i data-feather="play" class="feather icon-play"></i>`);

      case 'table':
        return this._sanitizer.bypassSecurityTrustHtml(`<i data-feather="layout" class="feather icon-layout"></i>`);

      case 'table-default-edit':
        return this._sanitizer.bypassSecurityTrustHtml(`<i data-feather="layout" class="feather icon-layout"></i>`);

      case 'date':
        return this._sanitizer.bypassSecurityTrustHtml(`<i data-feather="calendar" class="feather icon-calendar"></i>`);

      case 'radio':
        return this._sanitizer.bypassSecurityTrustHtml(`<i data-feather="circle" class="feather icon-circle"></i>`);

      case 'view':
        return this._sanitizer.bypassSecurityTrustHtml(`<i data-feather="eye" class="feather icon-eye"></i>`);

      case 'document-view':
        return this._sanitizer.bypassSecurityTrustHtml(`<i data-feather="eye" class="feather icon-eye"></i>`);

      case 'currency-view':
        return this._sanitizer.bypassSecurityTrustHtml(`<i data-feather="dollar-sign" class="feather icon-dollar-sign"></i>`);

      case 'select':
        return this._sanitizer.bypassSecurityTrustHtml(`<i data-feather="check" class="feather icon-check"></i>`);

      case 'button':
        return this._sanitizer.bypassSecurityTrustHtml(`<i data-feather="cpu" class="feather icon-cpu"></i>`);

      case 'number':
        return this._sanitizer.bypassSecurityTrustHtml(`<i data-feather="percent" class="feather icon-percent"></i>`);

      case 'attachment-details':
        return this._sanitizer.bypassSecurityTrustHtml(`<i data-feather="paperclip" class="feather icon-paperclip"></i>`);

      case 'action-history':
        return this._sanitizer.bypassSecurityTrustHtml(`<i data-feather="archive" class="feather icon-archive"></i>`);

      case 'purchaseOrder':
        return this._sanitizer.bypassSecurityTrustHtml(`<i data-feather="shopping-bag" class="feather icon-shopping-bag"></i>`);

      case 'invoiceUpload':
        return this._sanitizer.bypassSecurityTrustHtml(`<i data-feather="upload" class="feather icon-upload"></i>`);

      case 'tab':
        return this._sanitizer.bypassSecurityTrustHtml(`<i data-feather="tablet" class="feather icon-tablet"></i>`);

      case 'validate':
        return this._sanitizer.bypassSecurityTrustHtml(`<i data-feather="repeat" class="feather icon-repeat"></i>`);

      case 'checkbox':
        return this._sanitizer.bypassSecurityTrustHtml(`<i data-feather="check-square" class="feather icon-check-square"></i>`);

      case 'sub-heading':
        return this._sanitizer.bypassSecurityTrustHtml(`<i data-feather="bold" class="feather icon-bold"></i>`);

      case 'fileUpload':
        return this._sanitizer.bypassSecurityTrustHtml(`<i data-feather="upload" class="feather icon-upload"></i>`);

      case 'dragger':
        return this._sanitizer.bypassSecurityTrustHtml(`<i data-feather="upload-dragger" class="feather icon-upload-cloud"></i>`);

      case 'dateView':
        return this._sanitizer.bypassSecurityTrustHtml(`<i data-feather="calendar" class="feather icon-calendar"></i>`);

      case 'db-call':
        return this._sanitizer.bypassSecurityTrustHtml(`<i data-feather="database" class="feather icon-database"></i>`);
      case 'db-insert':
        return this._sanitizer.bypassSecurityTrustHtml(`<i data-feather="database" class="feather icon-database"></i>`);

      case 'api-call':
        return this._sanitizer.bypassSecurityTrustHtml(`<i data-feather="link" class="feather icon-link"></i>`);

      case 'call-procedure':
        return this._sanitizer.bypassSecurityTrustHtml(`<i data-feather="activity" class="feather icon-activity"></i>`);

      case 'rule':
        return this._sanitizer.bypassSecurityTrustHtml(`<i data-feather="cpu" class="feather icon-cpu"></i>`);
      
      case 'db-update':
        return this._sanitizer.bypassSecurityTrustHtml(`<i data-feather="edit" class="feather icon-edit"></i>`);

      case 'Plan':
        return this._sanitizer.bypassSecurityTrustHtml(`<i data-feather="Plan" class="feather icon-menu"></i>`);

        case 'select':
          return this._sanitizer.bypassSecurityTrustHtml(`<i data-feather="check" class="feather icon-check"></i>`);
        case 'Send-OTP':
        return this._sanitizer.bypassSecurityTrustHtml(`<i data-feather="repeat" class="feather icon-repeat"></i>`);
        case 'Tag':
          return this._sanitizer.bypassSecurityTrustHtml(`<i data-feather="tag" class="feather icon-tag"></i>`);
        case 'Popup-with-checkbox':
          return this._sanitizer.bypassSecurityTrustHtml(`<i data-feather="check-circle" class="feather icon-check-circle"></i>`);
  

      default:
        return this._sanitizer.bypassSecurityTrustHtml(`<i data-feather="mail" class="feather icon-mail"></i>`);
    }
  }

  isUndefined(variable: any): boolean {
    return (variable === undefined);
  }

  copyText(copyText) {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(copyText).then(() => {
        this.toast(CONSTATNT_DATA.DATA.API_STATUS.SUCCESS, "Copied to Clipboard", CONSTATNT_DATA.DATA.TOASTER.SUCCESS_TITLE);

      }, (error) => {
        this.toast(CONSTATNT_DATA.DATA.API_STATUS.ERROR, error, CONSTATNT_DATA.DATA.TOASTER.ERROR_TITLE);

      });
    }
  }

  exportToCsv(data: any[], columns: string[]): string {
    const header = columns.join(',');
    const rows = data.map(item => {
      return columns.map(col => {
        return item[col];
      }).join(',');
    });
    return [header, ...rows].join('\n');
  }

}

